import { Fragment, useState, useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';

/* MUI */
import { makeStyles } from '@material-ui/core/styles';
import { Container, Tabs, Tab, Typography, Badge, CssBaseline } from '@material-ui/core';

/* MobX */
import { observer } from 'mobx-react-lite';

const useStyles = makeStyles((theme) => ({
  heroContent: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(8, 0, 4),
    marginTop: theme.spacing(2),
  },
  wrapper: {
    textTransform: 'initial'
  }
}));

const AdminNavigation = observer(props => {
  const classes = useStyles();
  let navigate = useNavigate();
  let location = useLocation();
  const [selectedTab, setSelectedTab] = useState("/admin/users");
  let landUseCodeStore = props.store;

  useEffect(() => {
    if (location.pathname === "/admin") {
      setSelectedTab("/admin/users");
    } else {
      setSelectedTab(location.pathname);
    }
  }, [location.pathname])

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    navigate(newValue);
  }

  return (
    <Fragment>
      <CssBaseline />
      <Container maxWidth="lg" className={classes.heroContent} >
        <Typography
          component="h1"
          variant="h2"
          align="center"
          color="textPrimary"
          gutterBottom
        >
          Admin Dashboard
        </Typography>
        <Tabs value={selectedTab} onChange={handleTabChange} centered >
          {/* <Tab label="Business Dashboard" value="/admin/dashboard" className={classes.wrapper}/>
          <Tab label="Area Review" value="/admin/area" className={classes.wrapper}/> */}
          <Tab label="Users" value="/admin/users" className={classes.wrapper}/>
          <Tab label="Addresses" value="/admin/addresses" className={classes.wrapper}/>
          <Tab label={
            <Badge variant='dot' invisible={landUseCodeStore.unreviewedLandUseCode.length === 0}  color='error'>
              Land Use Code
            </Badge>
          } value="/admin/landusecode" className={classes.wrapper}/>
          <Tab label="Reports" value="/admin/reports" className={classes.wrapper}/>
          {/* <Tab label="Resources" value="/admin/resources" className={classes.wrapper}/> */}
        </Tabs>
      </Container>
      <Outlet />
    </Fragment>
  )
});

export default AdminNavigation;